import type { IPredictiveSearchProduct } from "@repo/shopify/src/queries/search-gql";
import classNames from "classnames";
import React from "react";

import ProductCard from "@components/molecules/Card/ProductCard";

import { getProductLaunch } from "@utils/product";

interface IProps {
  products: { node: IPredictiveSearchProduct }[];
  page?: string;
  className?: string;
  isSaleShutDown?: boolean;
}

function ProductGrid({ products = [], page = "", className = "", isSaleShutDown }: IProps) {
  return (
    <ul
      className={classNames(
        "grid",
        "pc:gap-x-5 pc:gap-y-10 grid-cols-2 gap-x-2.5 gap-y-5",
        page === "collection" ? "pc:grid-cols-3" : "pc:grid-cols-4",
        className,
      )}
    >
      {products.map((product) => (
        <li className="inline-block h-fit" id={product.node.id} key={product.node.id}>
          <ProductCard
            availableForSale={product.node.availableForSale}
            compareAtPrice={
              product.node.variants ? parseInt(product.node.variants.edges[0]?.node?.compareAtPrice?.amount ?? "0") : 0
            }
            featuredImage={product.node.featuredImage!}
            handle={product.node.handle}
            isSaleShutDown={isSaleShutDown}
            launchData={getProductLaunch(product.node)}
            price={product.node.variants ? parseInt(product.node.variants.edges[0]?.node.price?.amount ?? "0") : 0}
            product={product.node}
            tags={product.node.tags}
            title={product.node.title}
            vendor={product.node.vendor}
          />
        </li>
      ))}
    </ul>
  );
}

export default ProductGrid;
